import React, { useState } from "react";
import { TextField, Button, Container, Box, Typography, Paper } from "@mui/material";

export default function SmsSender() {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");

  const handleSend = async () => {
    // For now, just log. Later this will POST to Spring Boot.
    console.log({ phone, code, message });

    /*
    await fetch("/api/send-sms", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ phone, code, message })
    });
    */
  };

  const testBackend = async () => {
    try {
      const res = await fetch("api/hello");
      const text = await res.text();
      console.log("Backend says:", text);
    } catch (err) {
      console.log("Error calling backend:", err);
    }
  };

  return (
    
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Send SMS 
        </Typography>

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label="Phone Number"
            variant="outlined"
            fullWidth
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <TextField
            label="Verification Code"
            variant="outlined"
            type="password"
            fullWidth
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />

          <TextField
            label="Message"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />

          <Button
            variant="contained"
            size="large"
            onClick={sendSms}
          >
            Send
          </Button>

          <Button 
            variant="contained"
            size="large"
            onClick={testBackend}>
              Test backend GET
            </Button>
        </Box>
      </Paper>
    </Container>
  );
}


async function sendSms() {
  const payload = {
    phone: "+353871234567",
    message: "Hello from React 👋"
  };

  try {
    const res = await fetch("/api/send-sms", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    const text = await res.text();
    console.log("Backend response:", text);

  } catch (err) {
    console.error("POST failed:", err);
  }
}